import type { IError } from '.'

export class BaseError extends Error implements IError {
  public override readonly name: string
  public readonly code: number
  public readonly description: string
  public readonly isOperational: boolean

  constructor(
    name: string,
    code: number = 0,
    description: string = '',
    isOperational: boolean = true,
  ) {
    super(description)
    Object.setPrototypeOf(this, new.target.prototype)
    this.name = name
    this.isOperational = isOperational
    this.description = description
    this.code = code
    if (Error.captureStackTrace !== undefined) {
      Error?.captureStackTrace(this)
    }
  }
}
